@if (auth.auth.user) {
  @if (open) {
    <section class="assistant-panel" aria-label="Asistente de ayuda">
      <header>
        <div>
          <strong>Asistente Pineapple</strong>
          <span>Responde desde la documentación</span>
        </div>
        <button type="button" class="icon-button" (click)="open = false" aria-label="Cerrar asistente">×</button>
      </header>

      @if (taxonomy?.topics?.length) {
        <div class="scope-selector">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ text.scopeLabel }}</mat-label>
            <mat-select id="assistant-scope" [(ngModel)]="selectedTopic" [disabled]="loading">
              <mat-option value="">{{ text.scopeAny }}</mat-option>
              @for (domain of taxonomy.domains; track domain.id) {
                <mat-optgroup [label]="label(domain.labels)">
                  @for (topic of taxonomy.topics; track trackTopic($index, topic)) {
                    @if (topic.domain === domain.id) {
                      <mat-option [value]="topic.topic">{{ label(topic.labels) }}</mat-option>
                    }
                  }
                </mat-optgroup>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }

      <div class="messages" #messageList aria-live="polite">
        @if (!messages.length) {
          <div class="welcome">
            <strong>{{ text.welcomeTitle }}</strong>
            <p>{{ text.welcomeBody }}</p>
          </div>
        }
        @for (message of messages; track $index) {
          <div class="message" [class.user]="message.role === 'user'">
            <div class="bubble">
              <span>{{ message.content }}</span>

              @if (message.clarification) {
                <div class="clarify-options">
                  @for (option of message.clarification.options; track option.topic) {
                    <button
                      type="button"
                      class="clarify-chip"
                      [class.selected]="message.clarification.selectedTopic === option.topic"
                      [disabled]="loading || !!message.clarification.selectedTopic"
                      (click)="selectClarificationOption(message, option)"
                    >
                      {{ label(option.label) }}
                    </button>
                  }
                </div>
              }

              @if (message.citations?.length) {
                <div class="citations">
                  <span class="citations-title">{{ text.citationsTitle }}</span>
                  <ul>
                    @for (citation of message.citations; track $index) {
                      <li>{{ citation.documentTitle }} — {{ citation.heading }}</li>
                    }
                  </ul>
                </div>
              }
            </div>
          </div>
        }
        @if (loading) {
          <div class="message typing"><span></span><span></span><span></span></div>
        }
      </div>

      <footer>
        <textarea
          [(ngModel)]="question"
          (keydown)="onKeydown($event)"
          [disabled]="loading"
          rows="2"
          maxlength="4000"
          [placeholder]="text.placeholder"
          aria-label="Pregunta para el asistente"
        ></textarea>
        <button type="button" (click)="send()" [disabled]="loading || !question.trim()">{{ text.send }}</button>
      </footer>
    </section>
  }

  <button
    type="button"
    class="assistant-launcher"
    (click)="open = !open"
    [attr.aria-expanded]="open"
    aria-label="Abrir asistente de ayuda"
  >
    <span>?</span>
  </button>
}
